<section class="service-detail-section">
    <div>
        <div class="service-header">
            <img [src]="'./assets/images/services/accueil-et-gestion.png'" [alt]="'accueil-et-gestion'" class="service-image">
            <div class="social-icons">
                <a href="#" class="social-link">
                    <img src="assets/images/icons/facebook.png" alt="Facebook">
                </a>
                <a href="#" class="social-link">
                    <img src="assets/images/icons/instagram.png" alt="Instagram">
                </a>
                <a href="#" class="social-link">
                    <img src="assets/images/icons/linkedin.png" alt="LinkedIn">
                </a>
            </div>
        </div>

        <div class="service-container">
            <div class="service-container-header">
                <div class="left-side">
                    <h1>Accueil <br>et gestion</h1>
                </div>
                <div class="right-side">
                    <a [routerLink]="['/routePath']" routerLinkActive="router-link-active" class="service-link">
                        <img src="assets/images/icons/shield_check.png" alt="Shield icon" class="link-icon">
                        <span class="link-text">Demander notre service</span>
                        <img src="assets/images/icons/link_arrow.png" alt="Arrow" class="arrow-icon">
                    </a>
                </div>
            </div>
            <div class="service-content">
                <h2>Des prestations de réception à la hauteur de votre standing constituent votre carte de visite et donnent à vos visiteurs une image « positive » de votre organisation...</h2>
                <p>Centres commerciaux, complexes immobiliers, les administrations, les établissements financiers, bureaux, sites industriels, entrepôts, parkings, chantiers, centres aquatiques, foires commerciales, parcs d’attractions, VIP, … </p>
                <p class="mt-5 mb-2">Nous sommes là où vous en avez besoin :</p>
                <ul class="mb-4">
                    <li>Accueil et réception</li>
                    <li>Point d’information pour les visiteurs</li>
                    <li>Délivrance des badges, orientation des visiteurs</li>
                    <li>Accompagnement</li>
                    <li>Gestion des foules</li>
                    <li>Tâches administratives (copie, fax réception et distribution de courriers, …)</li>
                    <li>Gestion des vestiaires</li>
                    <li>Gestion des parkings</li>
                </ul>
                <p>L’équipe de nos agents « hôtesses et stewards » est familiarisée avec les tâches administratives et dans le cadre de ces missions, elle s’appuie sur leur prestance dégageant courtoisie et sociabilité mais également sur leur savoir en matière
                    de sécurité.</p>
            </div>
        </div>
    </div>
</section>